export const NOTHING = '—'

function orDash(value) {
    return value == null || value === '' ? NOTHING : value
}

export function resolveReplyRows(replies) {
    if (!Array.isArray(replies)) {
        return []
    }

    return replies.map((reply) => ({
        id: reply.id,
        subject: orDash(reply.subject),
        fromAddress: orDash(reply.fromAddress),
        receivedAt: reply.receivedAt,
        announcementTitle: orDash(reply.announcementTitle),
        sentAt: orDash(reply.sentAt),
    }))
}
